





















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Listing } from '../models/Listing';
import { Filter } from '../models/Filter';
import ListingUtil from '../utils/ListingUtil';
import Defs from '../utils/Defs';

@Component
export default class ListingTable extends Vue {

    get listingsInMapBounds(): Listing[] {
        const listings: Listing[] = [];
        const extraMultiListings: Listing[] = [];
        if (this.$store.state.listings.listingsInMapBounds) {
            for (const listing of this.$store.state.listings.listingsInMapBounds) {
                if (listing.ml === 1) {
                    const multiListings = JSON.parse(listing.md);
                    for (let j = 0; j < multiListings.length; j++) {
                        const multiListing = new Listing(multiListings[j]);
                        if (this.isListingFilteredOut(multiListing)) {
                            continue;
                        }
                        extraMultiListings.push(multiListing);
                    }
                } else {
                    listings.push(listing);
                }
            }
            return listings.concat(extraMultiListings);
        }
        return []; // table does not get inialized properly if data is null
    }

    get zoom(): number {
        return this.$store.state.zoom;
    }

    get leftDrawerOpen(): boolean {
        return this.$store.state.leftDrawerOpen;
    }

    get config() {
        return this.$store.state.config;
    }

    get isLoggedIn() {
        return this.$store.state.isLoggedIn;
    }

    get activeFilter(): Filter {
        return this.$store.state.filters.activeFilter;
    }

    get favouriteIds() {
        return this.$store.state.favourites.favouriteIds;
    }

    public columns = [
        {
            name: 'picture',
            required: true,
            label: '',
            align: 'left',
            field: (row: Listing) => '', // see slot
        },
        {
            name: 'info',
            required: true,
            label: '',
            align: 'left',
            field: (row: Listing) => '', // see slot
        },
    ];

    public initialPagination = {
        rowsPerPage: 15,
    };

    public getPictureUri(relativePath: string) {
        relativePath = ListingUtil.addTablePostfixToImage(relativePath);
        if (relativePath.indexOf(this.config.placeholdListingImg) !== -1) {
            return relativePath;
        }

        return this.config.imageRoot + relativePath;
    }

    public priceShortened(price: number) {
        return ListingUtil.getPriceShortened(price, 0);
    }
    public daysOnMarket(listing: Listing) {
        return ListingUtil.getDaysOnMarket(listing.ld, listing.st, listing.fd);
    }

    public isListingFilteredOut(listing: Listing) {
        if (this.activeFilter === null) {
            return false;
        }
        // Status
        if (this.activeFilter.Status.value !== null) {
            let lIsMatch = false;
            for (let x = 0; x < this.activeFilter.Status.value.length; x++) {
                if (this.activeFilter.Status.value[x] === listing.st) {
                    lIsMatch = true;
                }
            }
            if (lIsMatch === false) {
                return true;
            }
        }
        // Class
        if (this.activeFilter.Class.value !== null && this.activeFilter.Class.value.length > 0) {
            let lIsMatch = false;
            for (let i = 0; i < this.activeFilter.Class.value.length; i++) {
                if (this.activeFilter.Class.value[i] === listing.cl) {
                    lIsMatch = true;
                }
            }
            if (lIsMatch === false) {
                return true;
            }
        }

        // Heat
        if (this.activeFilter.HeatType.value !== null) {
            if (listing.ht === null) {
                return true;
            }
            let lIsMatch = false;
            for (let i = 0; i < this.activeFilter.HeatType.value.length; i++) {
                const listingHeat = listing.ht! as string;
                if (-1 !== listingHeat.indexOf(this.activeFilter.HeatType.value[i])) {
                    lIsMatch = true;
                }
            }
            if (lIsMatch === false) {
                return true;
            }
        }
        // Garage
        if (this.activeFilter.Garage.value !== null) {
            if (this.activeFilter.Garage.value !== listing.ga) {
                return true;
            }
        }
        // Waterfront
        if (this.activeFilter.Waterfront.value !== null) {
            if (this.activeFilter.Waterfront.value !== listing.wf) {
                return true;
            }
        }
        // Price
        if (this.activeFilter.Price.Min !== this.config.FilterOptions.PriceNoMinVal &&
            listing.lpmn < this.activeFilter.Price.Min) {
            return true;
        }
        if (this.activeFilter.Price.Max !== this.config.FilterOptions.PriceNoMaxVal &&
            listing.lpmn > this.activeFilter.Price.Max) {
            return true;
        }
        // Beds
        if (this.activeFilter.Beds.Min !== this.config.FilterOptions.BedNoMinVal &&
            listing.bdmn < this.activeFilter.Beds.Min) {
            return true;
        }
        if (this.activeFilter.Beds.Max !== this.config.FilterOptions.BedNoMaxVal &&
            listing.bdmn > this.activeFilter.Beds.Max) {
            return true;
        }
        // Baths
        if (this.activeFilter.Baths.Min !== this.config.FilterOptions.BathNoMinVal &&
            listing.bhmn < this.activeFilter.Baths.Min) {
            return true;
        }
        if (this.activeFilter.Baths.Max !== this.config.FilterOptions.BathNoMaxVal &&
            listing.bhmn > this.activeFilter.Baths.Max) {
            return true;
        }
        // Mla
        if (this.activeFilter.Mla.Min !== this.config.FilterOptions.MlaNoMinVal &&
            listing.mlan < this.activeFilter.Mla.Min) {
            return true;
        }
        if (this.activeFilter.Mla.Max !== this.config.FilterOptions.MlaNoMaxVal &&
            listing.mlan > this.activeFilter.Mla.Max) {
            return true;
        }
        // Tla
        if (this.activeFilter.Tla.Min !== this.config.FilterOptions.TlaNoMinVal &&
            listing.tlan < this.activeFilter.Tla.Min) {
            return true;
        }
        if (this.activeFilter.Tla.Max !== this.config.FilterOptions.TlaNoMaxVal &&
            listing.tlan > this.activeFilter.Tla.Max) {
            return true;
        }
        // Ageto
        if (this.activeFilter.Age.Min !== this.config.FilterOptions.AgeNoMinVal && listing.yb! < this.activeFilter.Age.Min) {
            return true;
        }
        if (this.activeFilter.Age.Max !== this.config.FilterOptions.AgeNoMaxVal && listing.yb! > this.activeFilter.Age.Max) {
            return true;
        }
    }

    public listingStatusClass(listing: Listing) {
        const status = listing!.st;
        if (status === '1' || status === '1_0') {
            return 'listTblPrice_FORSALE';
        } else if (status === '2' || status === '2_0') {
            return 'listTblPrice_SOLD';
        } else if (status === '3' || status === '3_0') {
            return 'listTblPrice_PEND';
        }
        return 'listTblPrice_NOSTATUS';
    }

    public listingStatus(listing: Listing) {
        const status = listing!.st;
        if (status === '1' || status === '1_0') {
            return 'FOR SALE';
        } else if (status === '2' || status === '2_0') {
            return 'SOLD';
        } else if (status === '3' || status === '3_0') {
            return 'PENDING';
        } else if (status === '4' || status === '4_0') {
            return 'EXPIRED';
        } else if (status === '5' || status === '5_0') {
            return 'CANCELLED';
        } else if (status === '5_1') {
            return 'WITHDRAWN';
        } else if (status === '6' || status === '6_0') {
            return 'RENTED';
        } else {
            return 'UNKNOWN';
        }
    }

    public onShowGallery(listing: Listing) {
        console.log('onShowGallery');
        if (!this.isLoggedIn && listing.st === '2') {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view details of sold listings.');
        } else {
            this.$store.dispatch('setSelectedListing', listing);
            this.$store.dispatch('sendListingEvent', { action: Defs.ANALYTICS_LISTING_TABLECLICK, sysId: listing.sid });
            this.$store.dispatch('showListingDialogPhotos');
        }
    }

    public onSelectListing(listing: Listing) {
        if (!this.isLoggedIn && listing.st === '2') {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view details of sold listings.');
        } else {
            this.$store.dispatch('closePopups');
            this.$store.dispatch('setSelectedListing', listing);
            this.$store.dispatch('sendListingEvent', { action: Defs.ANALYTICS_LISTING_TABLECLICK, sysId: listing.sid });
            this.$store.dispatch('showListingDialog');
        }
    }

    public isFavourite(listing: Listing) {
        if (!this.isLoggedIn) {
            return false;
        }

        if (listing) {
            return (this.favouriteIds.indexOf(listing.sid) !== -1);
        } else {
            return false;
        }
    }

    public onToggleFavorite(listing: Listing) {
        if (!this.isLoggedIn) {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to add to favourites.');
        } else {
            if (this.isFavourite(listing)) {
                this.$store.dispatch('favouriteRemove',  listing.sid);
            } else {
                this.$store.dispatch('favouriteAdd', listing.sid);
            }
        }
    }

    public onGoToListing(systemId: number) {
        this.$store.dispatch('goToListing', systemId);
    }
}
